import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import AnimateHeightPattern from '@mlb/react-patterns/components/AnimateHeight/animateHeight.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';
import ButtonPattern from '@mlb/react-patterns/components/Button/button.tsx';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';
import { Label } from '@mlb/react-patterns/components/Button/button.style.tsx';

import { Tracking } from 'bdvp-tracking';

const Wrapper = styled.div`
    width: 100%;
`;

const Button = styled(ButtonPattern)`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0;
    color: ${COLORS.mlbGrey2};
    font-weight: normal;
    ${Label} {
        display: inline-flex;
        margin-left: 0;
    }
    ${IconWrapper} {
        padding-top: 0;
        vertical-align: baseline;
    }
`;

const Title = styled.span`
    margin-left: 10px;
`;

const Pill = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: ${COLORS.linkBlueOnDark};
    border-radius: 8px;
    color: ${COLORS.mlbWhite};
    height: 15px;
    min-width: 15px;
    font-size: 11px;
    font-weight: 500;
    padding: 1px 5px;
    margin-left: 5px;
`;

const OUTLINE_FIX_WIDTH = '5px';

const AnimateHeight = styled(AnimateHeightPattern)`
    margin: 0 -${OUTLINE_FIX_WIDTH};
    padding: 0 ${OUTLINE_FIX_WIDTH};
`;

const Collapsible = (props) => {

    const {
        collapsedLabel,
        expandedLabel,
        selectedNumber,
        collapsible,
        filterName,
    } = props;

    const [
        expanded,
        setExpanded,
    ] = useState(false);

    const titleOnClickHandler = () => {

        setExpanded(!expanded);
        Tracking.trackFilterPanelCollapsibleClick(filterName, expanded);

    };

    return (
        <Wrapper>
            <Button
                iconName={expanded ? 'arrow-contract' : 'arrow-expand'}
                iconColor={COLORS.linkBlueOnDark}
                iconSize={16}
                size={'md'}
                styleName={'default'}
                shape={'hollow-borderless'}
                hasHover={false}
                handlers={{
                    onClick: titleOnClickHandler,
                }}
                aria-expanded={expanded}
                aria-controls={filterName}
            >
                <Title>{expanded ? expandedLabel : collapsedLabel}</Title>
                {
                    !expanded
                    && !!selectedNumber
                    && (
                        <Pill>{selectedNumber}</Pill>
                    )
                }
            </Button>
            <AnimateHeight
                expanded={expanded}
                collapsible={collapsible}
                aria-hidden={!expanded}
                id={filterName}
            />
        </Wrapper>
    );

};

Collapsible.propTypes = {
    collapsedLabel: PropTypes.string,
    expandedLabel: PropTypes.string,
    selectedNumber: PropTypes.number,
    collapsible: PropTypes.element,
    filterName: PropTypes.string.isRequired,
};

Collapsible.defaultProps = {
    collapsedLabel: 'See More',
    expandedLabel: 'See Fewer',
    selectedNumber: 0,
    collapsible: undefined,
};

export default Collapsible;
